import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ManageType } from 'src/app/decorators/type-manager-decorator';
import { CNMedication } from 'src/app/models/cnmedication';
import { CNTreatment } from 'src/app/models/cntreatment';
import { TreatmentService, TreatmentServiceFilter, TreatmentServiceSubject } from 'src/app/services/treatment.service';

@ManageType('MedicationTableComponent')
@Component({
  selector: 'app-medication-table',
  templateUrl: './medication-table.component.html',
  styleUrls: ['./medication-table.component.scss']
})
export class MedicationTableComponent implements OnInit {

  displayedColumns: string[] = ['medication'];
  public medications = new MatTableDataSource<CNMedication | CNTreatment>();
  public subject: TreatmentServiceSubject;
  private myLocation = 'default';
  private myFilter = TreatmentServiceFilter.all;

  @ViewChild('paginator', { static: true }) paginator;
  @Input() pageSize = 5;

  constructor(public medicationservice: TreatmentService) { }

  ngOnInit(): void {
    this.medicationservice.clear.subscribe(flag => {
      console.log('medications cleared');
      this.paginator.pageIndex = 0;
    });
  }

  @Input() set location(theLocation: string) {
    this.myLocation = theLocation;
    this.subject = this.medicationservice.getSubject(this.myLocation, this.myFilter, this.pageSize);
    this.subject.treatments.subscribe(data => {
      this.medications.data = data;
    });
  }

  changePage(event: PageEvent): void {
    if (!this.subject) {
      return;
    }
    const newStart = event.pageIndex * event.pageSize;
    if (newStart !== this.subject.start) {
      this.subject.start = newStart;
    }
    if (this.subject.limit !== event.pageSize) {
      this.subject.limit = event.pageSize;
    }
  }

  updated(event: CNMedication) {
    setTimeout(() => {
      this.subject.start = this.subject.start; // Force reload
    });
  }
}
